import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah M.',
      location: 'United States',
      text: 'Used this for my Thailand visa application. The ticket looked professional and was accepted without any issues. Received it instantly!',
      rating: 5
    },
    {
      name: 'James K.',
      location: 'Australia',
      text: 'Perfect for border crossings. I\'ve used it multiple times for Southeast Asia travel. Quick, easy, and reliable service.',
      rating: 5
    },
    {
      name: 'Maria L.',
      location: 'Germany',
      text: 'Needed an onward ticket for Indonesia visa. The process was straightforward and the ticket arrived in my email within seconds.',
      rating: 5
    },
    {
      name: 'David R.',
      location: 'United Kingdom',
      text: 'Great service! The ticket format looks authentic and I had no problems using it for my visa application. Highly recommend!',
      rating: 5
    }
  ];

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h3 className="text-center mb-4">What Our Users Say</h3>
          <p className="text-center text-muted mb-4">
            Trusted by 100,000+ travelers worldwide for visa applications and border crossings
          </p>
          
          <div className="row g-3">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="col-12 col-md-6">
                <div className="card h-100">
                  <div className="card-body">
                    <div className="mb-2">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="bi bi-star-fill text-warning"></i>
                      ))}
                    </div>
                    <p className="card-text">"{testimonial.text}"</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong className="small">{testimonial.name}</strong>
                        <div className="text-muted small">{testimonial.location}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;

